<template>
  <Transition name="fade">
    <div class="goods-list" v-if="lesson.length">
      <div class="goods-item" v-for="item in lesson" :key="item._id">
        <RouterLink
          :title="item.grade?.prTeachTimeName"
          target="_blank"
          :to="`/video/videodetail?clID=${item.clID}&id=${item.id}`"
          class="image"
        >
          <img v-lazy="item.coverImg" :key="item.coverImg" alt="" />
          <div class="pr-tag">
            <i class="pr-year" title="课程年份">{{ item.grade.grYear }}</i>
            <i class="pr-way" title="学习方式">{{
              item.grade.prTeachWayName
            }}</i>
          </div>
          <p class="grade" v-if="item.grade.grName.length <= 4">
            {{ item.grade.grName }}
          </p>
          <p class="grade1" v-if="item.grade.grName.length > 4">
            {{ item.grade.grName }}
          </p>
          <p class="name ellipsis-2">
            {{ item.grade.grYear }}{{ item.leName }}
          </p>
          <div class="price">
            <span class="old-price">&yen;{{ item.grade.grPrice }}</span>
            <span class="new-price">&yen;{{ item.grade.salePrice }}</span>
          </div>
        </RouterLink>
      </div>
    </div>
    <VideoItemSkeleton v-else />
  </Transition>
</template>

<script>
import VideoItemSkeleton from "./video-item-skeleton.vue";
export default {
  name: "VideoItem",
  components: {
    VideoItemSkeleton,
  },
  props: {
    lesson: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped lang="less">
.goods-list {
  display: flex;
  flex-wrap: wrap;
  //margin-left: 5px;
  width: 1240px;
  margin: 0 auto;
  min-height: 613px;
  //background: #999;
  .goods-item {
    margin-right: 5.333px;

    background: #f4f4f4;
    width: 306px;
    height: 306.5px;
    position: relative;
    overflow: hidden;
    border: 1px solid #fff;
    transition: all 0.5s;
    &:nth-child(4n) {
      margin-right: 0px;
    }
    &:nth-last-child(-n + 4) {
      margin-bottom: 0;
    }
    .pr-tag {
      display: inline-block;
      position: absolute;
      top: 0px;
      right: 0px;
      .pr-way {
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
      }
      .pr-year {
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
        margin-right: 5px;
      }
    }
    .grade {
      position: absolute;
      font-weight: bold;
      top: 48.5%;
      left: 38.5%;
    }
    .grade1 {
      position: absolute;
      font-weight: bold;
      top: 48.5%;
      left: 34.5%;
    }
    .image {
      display: block;
      width: 306px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      margin: 6px 5px 10px 5px;
      height: 45px;
      font-size: 16px;
    }
    .price {
      display: flex;
      justify-content: space-around;
      .old-price {
        padding-left: 8px;
        color: @priceColor;
        font-size: 16px;
        height: 16px;
        text-decoration: line-through;
      }
      .new-price {
        margin-left: 8px;
        color: @priceColor;
        font-size: 16px;
        height: 16px;
      }
    }

    &:hover {
      border-color: @shColor;
    }
  }
}
</style>
